import { useEffect } from 'react';
import { TourConfig, startTour, CONTINUE_PLATFORM_TOUR_BUTTON } from './TourSystem';
import PageWelcomeModal from './PageWelcomeModal';
import 'driver.js/dist/driver.css';

const skillsTourConfig: TourConfig = {
    tourId: 'skills',
    steps: [
        {
            element: '#skills-title',
            popover: {
                title: '🌌 The Skills Matrix',
                description: 'Welcome to your professional DNA. This matrix allows you to visualize, track, and expand your capabilities in a way never before possible. Your growth starts here.',
                side: "bottom",
            }
        },
        {
            element: '#skills-add',
            popover: {
                title: '➕ Add New Skills',
                description: 'Click this button to open the Skill Creator. You can select from thousands of verified industry skills or define your own custom expertise. Every skill you add increases your visibility to potential clients.',
                side: "left",
            }
        },
        {
            element: '#skills-tabs',
            popover: {
                title: '👀 Visualization Modes',
                description: 'We offer two powerful ways to view your data. Use these tabs to switch between the immersive "3D Universe" and the detailed "Manage Skills" list.',
                side: "bottom",
            }
        },
        {
            element: '#skills-tab-3d',
            popover: {
                title: '🪐 3D Universe View',
                description: 'Currently selected: see your skills as a living galaxy. Larger planets represent stronger skills. Connected stars show related technologies. It is not just data; it is a universe of potential.',
                side: "bottom",
            }
        },
        {
            element: '#skills-tab-manage',
            popover: {
                title: '📝 Manage Skills View',
                description: 'Click here to switch to a detailed table view. This mode allows for quick editing, deleting, and updating of proficiency levels for multiple skills at once.',
                side: "bottom",
            }
        },
        {
            element: '#skills-content-area',
            popover: {
                title: '📊 Active Workspace',
                description: `This is where your skills live. In 3D mode, drag and zoom to explore. In List mode, sort and filter your table. Keep this area populated to unlock more dispatch opportunities!${CONTINUE_PLATFORM_TOUR_BUTTON}`,
                side: "top",
            }
        }
    ],
};

export const startSkillsTour = () => {
    startTour(skillsTourConfig);
};

const SkillsTour = () => {
    return (
        <PageWelcomeModal
            title="Welcome to Skills Tour"
            description="Let us show you around Skills Tour quickly."
            onStartTour={startSkillsTour}
            tourId="skills"
        />
    );
};

export default SkillsTour;
